import React from "react";
import { useState } from "react";

const Helpers = () => {
  const [count, setCount] = useState<number>(0);

  const increment = () => setCount(count + 1);
  const decrement = () => setCount(count > 0 ? count - 1 : 0);

  return (
    <div>
      <div className="bg-gray-200" style={{ borderRadius: "15px" }}>
        <div className="flex items-center justify-center space-x-4">
          <div className="text-gray-500">Quantité</div>
          <button
            onClick={decrement}
            className=" text-black px-3 py-1 rounded-full "
          >
            -
          </button>
          <span className="text-1xl font-semibold">{count}</span>
          <button
            onClick={increment}
            className="text-black px-3 py-1 rounded-full"
          >
            +
          </button>
        </div>
      </div>
    </div>
  );
};

export default Helpers;
